module.exports = __webpack_public_path__ + "static/media/hz_tu4.0bac3525.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/hz_tu4.jpg
// module id = 1591
// module chunks = 10